import CryptoJS from "crypto-js";
import { useEffect } from "react";
import { REACT_APP_KEY_ENCRYPT_URL, REACT_APP_QRPOINT_ENDPOINT } from "src/constants";
import { Storage } from "src/services";

export default function Finance() {
  useEffect(() => {
    const data = String(Storage.getUserId());

    if (REACT_APP_KEY_ENCRYPT_URL && data) {
      const encryptedData = CryptoJS.AES.encrypt(data, REACT_APP_KEY_ENCRYPT_URL);
      const encodedEncryptedData = encodeURIComponent(encryptedData.toString());
      return window.location.replace(
        `${REACT_APP_QRPOINT_ENDPOINT}/fast-login?data=${encodedEncryptedData}&route=finance/plans?desc=corporativo`,
      );
    }
  }, []);

  return <></>;
}
